import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export function SkeletonRow({ cols = 6 }) {
    return (_jsx("tr", { className: "skeleton-row", children: Array.from({ length: cols }).map((_, i) => (_jsx("td", { children: _jsx("div", { className: "skeleton-cell", style: { width: i === 0 ? 80 : i === 1 ? 140 : 100 } }) }, i))) }));
}
export function SkeletonTable({ rows = 5, cols = 6 }) {
    return (_jsx(_Fragment, { children: Array.from({ length: rows }).map((_, i) => (_jsx(SkeletonRow, { cols: cols }, i))) }));
}
export function SkeletonBlock({ height = 40, width = "100%" }) {
    return _jsx("div", { className: "skeleton-block", style: { height, width } });
}
